import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { PanelTemplatePipe } from '@widgets/ui-common/pipes/panel-template-ref/panel-template-ref.pipe';
import { QueryListToArrayPipe } from '@widgets/ui-common/pipes/query-list-to-array/query-list-to-array.pipe';
import { NgxMaskModule } from 'ngx-mask';
import { ProgressBarModule } from './components/progress-bar/progress-bar.module';
import { ColorBatchStatusDirective } from './directives/color-batch-status.directive';
import { FileInputDirective } from './directives/file-input.directive';
import { MaterialModule } from './material/material.module';
import { AddressPipePipe } from './pipes/address-pipe/address-pipe.pipe';
import { AnalysisParameterPipe } from './pipes/analysis-parameter/analysis-parameter.pipe';
import { BatchHistoryStatusPipe } from './pipes/batch-history-status/batch-history-status.pipe';
import { BatchStatusPipe } from './pipes/batch-status/batch-status.pipe';
import { ByteSizePipe } from './pipes/byte-size/byte-size.pipe';
import { DatePipe } from './pipes/date/date.pipe';
import { EnumPipe } from './pipes/enum/enum.pipe';
import { EveryPipe } from './pipes/every/every.pipe';
import { FileExtPipe } from './pipes/file-ext/file-ext.pipe';
import { FormErrorPipe } from './pipes/form-error/form-error.pipe';
import { IsEqualToPipe } from './pipes/is-equal-to/is-equal-to.pipe';
import { IsInPipe } from './pipes/is-in/is-in.pipe';
import { IsNotInPipe } from './pipes/is-not-in/is-not-in.pipe';
import { MapArrPipe } from './pipes/map-arr/mapArr.pipe';
import { MapOnePipe } from './pipes/map-one/map-one.pipe';
import { NotEqualToPipe } from './pipes/not-equal-to/not-equal-to.pipe';
import { PadZeroesPipe } from './pipes/pad-zeroes/pad-zeroes.pipe';
import { PhoneNumberExtentionPipe } from './pipes/phone-number-extention/phone-number-extention.pipe';
import { PhoneNumberPipe } from './pipes/phone-number/phone-number.pipe';
import { SiteUserToUserPipe } from './pipes/site-user-to-user/site-user-to-user.pipe';
import { SoilDescriptionTypePipe } from './pipes/soil-description-type/soil-description-type.pipe';
import { SoilQualityTypePipe } from './pipes/soil-quality-type/soil-quality-type.pipe';
import { SourceSiteTypePipe } from './pipes/source-site-type/source-site-type.pipe';
import { SourceTypePipe } from './pipes/source-type/source-type.pipe';
import { StrReplacePipe } from './pipes/strReplace/str-replace.pipe';
import { UploadErrorPipe } from './pipes/upload-error';
import { UserStatusPipe } from './pipes/user-status/user-status.pipe';
import { YesNoPipe } from './pipes/yes-no/yes-no.pipe';

export const UI_COMMON_PIPES = [
  QueryListToArrayPipe,
  SiteUserToUserPipe,
  PanelTemplatePipe,
  EnumPipe,
  IsInPipe,
  ByteSizePipe,
  FormErrorPipe,
  SourceTypePipe,
  SourceSiteTypePipe,
  SoilDescriptionTypePipe,
  SoilQualityTypePipe,
  AnalysisParameterPipe,
  IsEqualToPipe,
  NotEqualToPipe,
  MapArrPipe,
  PadZeroesPipe,
  BatchStatusPipe,
  EveryPipe,
  StrReplacePipe,
  DatePipe,
  MapOnePipe,
  IsNotInPipe,
  UploadErrorPipe,
  FileExtPipe,
  BatchHistoryStatusPipe,
  PhoneNumberPipe,
  PhoneNumberExtentionPipe,
  UserStatusPipe,
  YesNoPipe,
  AddressPipePipe
];

const UI_COMMON_MODULES = [CommonModule, MaterialModule, ReactiveFormsModule, NgxMaskModule, NgSelectModule,
  ProgressBarModule, TranslateModule];
const UI_COMMON_DIRECTIVES = [FileInputDirective, ColorBatchStatusDirective];
@NgModule({
  imports: [...UI_COMMON_MODULES],
  exports: [...UI_COMMON_MODULES, ...UI_COMMON_PIPES, ...UI_COMMON_DIRECTIVES],
  declarations: [...UI_COMMON_PIPES, ...UI_COMMON_DIRECTIVES]
})
export class UiCommonModule { }
